// Tarifs : la formule annuelle en bleu nuit, la mensuelle en blanc, et la
// garantie en ligne dessous — pas une troisième carte.
import { Link } from 'react-router-dom'
import { useT } from '../../lib/i18n'
import { Check, Shield } from './Icons'

export default function Plans () {
  const p = useT().plans

  return (
    <section className="lp-sec lp-sec--alt" id="pricing">
      <div className="lp-wrap">
        <div className="lp-head lp-head--center lp-rv">
          <span className="lp-kicker">{p.kicker}</span>
          <h2 className="lp-h2">{p.title}</h2>
          <p className="lp-lead">{p.lead}</p>
        </div>

        <div className="lp-plans">
          <div className="lp-plan lp-rv">
            <span className="lp-plan__n">{p.monthlyName}</span>
            <div className="lp-plan__price">{p.monthlyPrice}<small>{p.monthlyPer}</small></div>
            <p className="lp-plan__save">{p.monthlyDay}</p>
            <ul className="lp-plan__l">{p.monthly.map(x => <li key={x}><Check />{x}</li>)}</ul>
            <Link to="/register?plan=monthly" className="lp-btn lp-btn--ghost lp-btn--full">{p.ctaMonthly}</Link>
            <p className="lp-plan__fine">{p.fineMonthly}</p>
          </div>

          <div className="lp-plan lp-plan--best lp-rv">
            <span className="lp-plan__badge">{p.best} · {p.off}</span>
            <span className="lp-plan__n">{p.yearlyName}</span>
            <div className="lp-plan__price">
              {p.yearlyPrice}<small>{p.yearlyPer}</small>
            </div>
            <p className="lp-plan__save"><b>{p.yearlyDay}</b> · <s>{p.yearlyOld}</s></p>
            <ul className="lp-plan__l">{p.yearly.map(x => <li key={x}><Check />{x}</li>)}</ul>
            <Link to="/register?plan=yearly" className="lp-btn lp-btn--white lp-btn--full">{p.ctaYearly}</Link>
            <p className="lp-plan__fine">{p.fineYearly}</p>
          </div>
        </div>

        <div className="lp-guar lp-rv">
          <span className="lp-guar__ic"><Shield /></span>
          <span><b>{p.guarT}</b> {p.guarP}</span>
        </div>
        <p className="lp-fine lp-fine--center">{p.note}</p>
      </div>
    </section>
  )
}
